import React from 'react';

// Extract leading emoji from title string
function splitEmoji(title) {
  const m = title.match(/^(\p{Emoji_Presentation}|\p{Emoji}️?)\s*/u);
  if (m) return { emoji: m[1], text: title.slice(m[0].length).trim() };
  return { emoji: null, text: title };
}

export function DocumentHeader({ title, date, summaryItems = [] }) {
  const { emoji, text: cleanTitle } = splitEmoji(title);
  const hasSummary = summaryItems.length > 0;

  return (
    <div style={{
      margin: '0 0 16px',
      padding: '14px 16px',
      background: 'rgba(6,14,40,0.6)',
      border: '1px solid rgba(56,189,248,0.14)',
      borderRadius: 12,
      fontFamily: 'inherit',
    }}>
      {/* Title row */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: 11, marginBottom: hasSummary ? 12 : 0 }}>
        {emoji && (
          <span style={{ fontSize: 20, lineHeight: 1.2, flexShrink: 0, marginTop: 1 }}>{emoji}</span>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontSize: 15.5, fontWeight: 700, color: '#f0f4ff',
            letterSpacing: '.01em', lineHeight: 1.3,
            marginBottom: date ? 3 : 0,
          }}>
            {cleanTitle}
          </div>
          {date && (
            <div style={{ fontSize: 11, color: 'rgba(107,122,170,0.75)', letterSpacing: '.03em' }}>
              {date}
            </div>
          )}
        </div>
      </div>

      {/* Executive summary */}
      {hasSummary && (
        <div style={{
          borderTop: '1px solid rgba(56,189,248,0.1)',
          paddingTop: 11,
        }}>
          <div style={{
            fontSize: 9.5, letterSpacing: '.08em', textTransform: 'uppercase',
            color: 'rgba(56,189,248,0.5)', marginBottom: 9,
          }}>
            📋 Resumo Executivo
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {summaryItems.map((item, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 9 }}>
                <span style={{ color: '#38bdf8', flexShrink: 0, fontSize: 14, lineHeight: 1.2, marginTop: 1 }}>·</span>
                <span style={{ fontSize: 12.5, color: 'rgba(172,196,236,0.8)', lineHeight: 1.5 }}>
                  {item}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
